export default __webpack_public_path__ + "static/media/SCIENCE_BIOLOGY.dcdd8968.svg";